<template>
  <v-btn
    v-if="buttonTitle"
    :id="articleId"
    :aria-label="articleId"
    v-html="buttonTitle"
    class=" justify-start text-xs-left fill-height mx-2 my-1 fab-text fill-width"
    @click="checkType"
    role="button">
  </v-btn>
</template>

<script>
  import { POST_STUDENT_HELP_POPUP_ARTICLE } from '../../../store/action-types'
  import { mapActions } from 'vuex'

  export default {
    name: 'fab-button',
    props: {
      article: {
        required: true,
        type: Object
      }
    },
    data () {
      return {}
    },
    methods: {
      ...mapActions({
        postHelpPopUpArticle: POST_STUDENT_HELP_POPUP_ARTICLE
      }),
      checkType () {
        this.postHelpPopUpArticle(this.getIdentifier)
        this.$emit('close-help-popup')
        if (this.internalLink) {
          this.$router.push(`/support/${this.getIdentifier}`)
        } else if (this.faqLink) {
          this.$router.replace(`/help/${this.buttonLink}`)
        } else {
          window.open(this.getLink, '_blank')
        }
      }
    },
    computed: {
      buttonTitle () {
        return this.article.title
      },
      buttonType () {
        return this.article.type
      },
      buttonLink () {
        return this.article.link
      },
      internalLink () {
        return this.buttonType === 'internal' || this.buttonType === 'INTERNAL'
      },
      faqLink () {
        return this.buttonType === 'faq' || this.buttonType === 'FAQ'
      },
      articleId () {
        return 'student-help-article-' + this.getIdentifier
      },
      getIdentifier () {
        return this.article.identifier
      },
      getLink () {
        return this.buttonLink
      }
    }
  }
</script>

<style scoped>
  .fab-text {
    padding: 0.5em 1em;
    margin: 10px 0;
    box-shadow: 0 7px 8px -4px rgba(0,0,0,.2), 0 12px 17px 2px rgba(0,0,0,.14), 0 5px 22px 4px rgba(0,0,0,.12);
    text-transform: unset !important;
  }

  .fill-width {
    width: 100%
  }
</style>



// WEBPACK FOOTER //
// src/components/misc/fab/FabHelpButton.vue